import React from "react";
import { useNavigate } from "react-router-dom";

const SubscriptionCancelled = () => {
    const navigate = useNavigate();

    return (
        <div className="cancel-container">
            <h1>❌ Payment Cancelled</h1>
            <p>Your payment was not completed. You can try again anytime.</p>
            <button onClick={() => navigate("/subscription")}>Go Back</button>
        </div>
    );
};

export default SubscriptionCancelled;
